import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: "Cos'è itaobuy spreadsheet?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Itaobuy spreadsheet è un database organizzato di prodotti suddivisi per categorie, con link diretti, foto QC e recensioni. È lo strumento ideale per gli utenti italiani che vogliono fare shopping online in modo intelligente.",
      },
    },
    {
      '@type': 'Question',
      name: 'Itaobuy è legale?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Sì, itaobuy è legale. Opera come agente di shopping che facilita gli acquisti da piattaforme terze.",
      },
    },
    {
      '@type': 'Question',
      name: 'Quanto costa la spedizione in Italia?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'I costi variano in base al peso e al metodo scelto, generalmente tra 15 e 40 euro.',
      },
    },
    {
      '@type': 'Question',
      name: "Posso usare itaobuy dall'Italia?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Assolutamente sì. Itaobuy è accessibile dall'Italia e molti utenti italiani lo utilizzano regolarmente.",
      },
    },
    {
      '@type': 'Question',
      name: 'Come scelgo la taglia giusta?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Consulta le tabelle misure nel database e leggi le recensioni di altri utenti.',
      },
    },
    {
      '@type': 'Question',
      name: 'Quanto tempo ci vuole per la consegna?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Generalmente 7-21 giorni lavorativi per la spedizione standard.',
      },
    },
  ],
};

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ FAQ</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              FAQ Itaobuy Spreadsheet: Domande Frequenti
            </h1>
            <p className="text-background-50/70 text-sm md:text-base">Risposte alle domande più comuni su <strong className="text-background-50">itaobuy spreadsheet</strong>: funzionamento, sicurezza, costi e molto altro.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per accedere al database completo.</p>
            </div>

            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-6">Domande Frequenti</h2>

              <div className="space-y-6">
                <div>
                  <h3 className="font-semibold text-foreground-950 mb-2">Cos'è itaobuy spreadsheet?</h3>
                  <p className="text-sm"><strong className="text-foreground-950">Itaobuy spreadsheet</strong> è un database organizzato di prodotti suddivisi per categorie, con link diretti, foto QC e recensioni. È lo strumento ideale per gli utenti italiani che vogliono fare shopping online in modo intelligente. Scopri di più nella <Link to="/guida-itaobuy-spreadsheet-italiano" className="text-primary-600 font-medium hover:underline">guida completa</Link>.</p>
                </div>

                <div>
                  <h3 className="font-semibold text-foreground-950 mb-2">Itaobuy è legale?</h3>
                  <p className="text-sm">Sì, <strong className="text-foreground-950">itaobuy è legale</strong>. Opera come agente di shopping che facilita gli acquisti da piattaforme terze. Per maggiori dettagli, consulta la <Link to="/itaobuy-e-sicuro" className="text-primary-600 font-medium hover:underline">guida alla sicurezza</Link>.</p>
                </div>

                <div>
                  <h3 className="font-semibold text-foreground-950 mb-2">Quanto costa la spedizione in Italia?</h3>
                  <p className="text-sm">I costi variano in base al peso e al metodo scelto, generalmente tra 15 e 40 euro. Vedi la <Link to="/itaobuy-spedizione-italia" className="text-primary-600 font-medium hover:underline">guida completa alla spedizione</Link>.</p>
                </div>

                <div>
                  <h3 className="font-semibold text-foreground-950 mb-2">Posso usare itaobuy dall'Italia?</h3>
                  <p className="text-sm">Assolutamente sì. <strong className="text-foreground-950">Itaobuy è accessibile dall'Italia</strong> e molti utenti italiani lo utilizzano regolarmente. Visita la <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per iniziare.</p>
                </div>

                <div>
                  <h3 className="font-semibold text-foreground-950 mb-2">Come scelgo la taglia giusta?</h3>
                  <p className="text-sm">Consulta le tabelle misure nel database e leggi le recensioni di altri utenti. Per le sneakers, vedi la <Link to="/itaobuy-spreadsheet-sneakers" className="text-primary-600 font-medium hover:underline">guida alle sneakers</Link>.</p>
                </div>

                <div>
                  <h3 className="font-semibold text-foreground-950 mb-2">Quanto tempo ci vuole per la consegna?</h3>
                  <p className="text-sm">Generalmente 7-21 giorni lavorativi per la spedizione standard. Leggi la <Link to="/itaobuy-spedizione-italia" className="text-primary-600 font-medium hover:underline">guida alla spedizione</Link> per i dettagli.</p>
                </div>
              </div>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Altre Domande?</h3>
              <p className="text-sm text-foreground-600 mb-5">Esplora il database e trova tutte le risposte che cerchi.</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                buy it now <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400"><strong className="text-foreground-500">FAQ itaobuy spreadsheet</strong> — <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}